// Same options, labels and descriptions as the console's
// `src/pages/AdTemplates/adTypeOptions.js` (sourced from FbAdvertisment/adsHelper).
export const AD_TYPE_AUTO = 'auto';

export type AdTypeOption = {
  value: string;
  label: string;
  description: string;
};

export const AD_TYPE_OPTIONS: AdTypeOption[] = [
  {
    value: AD_TYPE_AUTO,
    label: 'Let AI decide',
    description: 'Pick the best ad type for each ad',
  },
  {
    value: 'ctwa',
    label: 'Click to WhatsApp',
    description: 'Start a WhatsApp conversation from your ad',
  },
  {
    value: 'website_to_whatsapp',
    label: 'Website to WhatsApp',
    description: 'Website visits with a WhatsApp button',
  },
  {
    value: 'website_traffic',
    label: 'Website',
    description: 'Send people to a product or landing page',
  },
  {
    value: 'whatsapp_status',
    label: 'Status',
    description: 'Reach customers inside WhatsApp Status',
  },
];

export const adTypeLabel = (value: string): string =>
  (AD_TYPE_OPTIONS.find((o) => o.value === value) || AD_TYPE_OPTIONS[0]).label;

// Full names the console's ad cards show (FbAdvertisment/adsHelper AD_TYPES).
const AD_TYPE_CARD_LABELS: Record<string, string> = {
  ctwa: 'Click to WhatsApp Ad',
  whatsapp_status: 'WhatsApp Status Ad',
  website_to_whatsapp: 'Website to WhatsApp Ad',
  website_traffic: 'Website Ad',
};

export const typeLabelOf = (adType: string): string =>
  AD_TYPE_CARD_LABELS[adType] || 'Ad';

export const isStatusAdType = (value: string): boolean =>
  value === 'whatsapp_status';

export const STATUS_ASPECT_RATIO = '9:16';
